import { atom } from 'jotai'
import { ExpenseGroup } from 'src/services/expenses/'

export const copiedExpenseAtom = atom<ExpenseGroup | null>(null)
